import { createAction, props } from '@ngrx/store';
import { IQuestion, IUserAnswer } from './csat.declarations';

export const getQuestionsInfo = createAction('[CSAT] Get Questions Info');

export const getQuestionsInfoSuccess = createAction(
  '[CSAT] Get User Answer Last Date Success',
  props<{ lastAnswerDate: string, questionsList: IQuestion[] }>()
);

export const saveUserAnswer = createAction(
  '[CSAT] Save User Answer',
  props<{ satisfactionAnswersList: IUserAnswer[] }>()
)

export const saveUserAnswerSuccess = createAction('[CSAT] Save User Answer Success')
export const saveUserAnswerError = createAction('[CSAT] Save User Answer Error')

export const getQuestionsInfoError = createAction('[CSAT] Get User Answer Last Date Error')
